/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q1Inputs */

const et_faq_q1 = /** @type {(inputs: Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas saada oma ettevõte Google Mapsis ja kohalikes otsingutes esile?`)
};

const en_faq_q1 = /** @type {(inputs: Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I get my business to stand out on Google Maps and in local search?`)
};

/**
* | output |
* | --- |
* | "How can I get my business to stand out on Google Maps and in local search?" |
*
* @param {Faq_Q1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q1 = /** @type {((inputs?: Faq_Q1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q1(inputs)
	return en_faq_q1(inputs)
});